// eslint-disable-next-line import/no-amd
define([
    'jquery',
    'underscore',
    'backbone',
    '../../app/views/ConfirmView',
    '../../app/views/AlertView',
    '../models/SchemaModel',
    '../templates/detail_view.template'
], ($, _, Backbone, ConfirmView, AlertView, SchemaModel, html) => {
    const DetailView = Backbone.View.extend({
        model: null,
        oldPass: '(old Password)',
        initialize(options) {
            this.options = options || {};
        },
        render(id) {
            this.$('form').validationEngine('hideAll');
            $.scrollTo('#hauptrahmen', 300);
            this.model = new SchemaModel({ id });
            const view = this;
            $(this.el).spinner();
            if (_.isUndefined(id)) {
                view.oldPass = '';
                this.renderTemplate(view.model);
            } else {
                this.model.fetch({
                    success() {
                        view.renderTemplate(view.model);
                    }
                });
            }
        },
        renderTemplate(model) {
            const view = this;
            view.options.listView.$('div.schema-content-detail').html(_.template(html)({ model: view.model, $ }));
            view.setElement('#schema-detail-view');
            const { oldPass } = this;
            if (model.get('passwordEmpty')) {
                view.$('#passwordText').attr('disabled', 'disabled').hide();
            } else {
                view.$('#password').attr('disabled', 'disabled').hide();
                view.$('#password').val(oldPass);
                view.$('#passwordText').val(oldPass);
            }

            view.$el.fadeIn();
        },
        events: {
            'submit #schema-form': 'saveModel',
            'click #delete-schema': 'deleteModel',
            'focus #passwordText': 'focusPasswordText',
            'blur #password': 'blurPassword'
        },
        focusPasswordText() {
            const view = this;
            view.$('#password').removeAttr('disabled').show();
            view.$('#password').focus();
            view.$('#passwordText').attr('disabled', 'disabled').hide();
        },
        blurPassword() {
            const view = this;
            if (view.$('#password').val() === view.oldPass) {
                view.$('#password').attr('disabled', 'disabled').hide();
                view.$('#passwordText').removeAttr('disabled').show();
            }
        },
        saveModel() {
            const view = this;
            this.model.clear({ silent: true });
            this.model.setForm(this.$('form'));
            this.model.save(formMessage => {
                if (formMessage.showErrors()) {
                    // view.$("form").validationEngine('hide');
                    AlertView.show({
                        message: $._('schema.alert.save.success'),
                        title: $._('alert.action.success'),
                        okFunc() {
                            if (_.isUndefined(view.model.id)) {
                                view.options.listView.render();
                            } else {
                                view.render(view.model.id);
                            }
                        }
                    });
                }
            });
            return false;
        },
        deleteModel() {
            const view = this;
            ConfirmView.show({
                message: $._('schema.form.message.delete'),
                title: $._('alert.action.delete'),
                yesFunc() {
                    view.model.destroy({
                        success(mode, data) {
                            AlertView.show({
                                message: data.hasErrors ? data.errors[0].message : $._('schema.alert.delete.success'),
                                title: data.hasErrors ? 'alert.action.nosuccess' : $._('alert.action.success'),
                                okFunc() {
                                    if (!data.hasErrors) {
                                        view.options.listView.render();
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }

    });
    return DetailView;
});



// WEBPACK FOOTER //
// ./src/components/schema/views/DetailView.js